import { TCheckboxSize, TCheckboxType } from './interfaces';
import { css } from '@emotion/css'
import colors from '@styles/colors';

const checkboxOptions = {
    CHECKBOX: {
        MINI: { width: 16, height: 16, fontSize: 12 },
        SMALL: { width: 20, height: 20, fontSize: 16 },
        MEDIUM: { width: 22, height: 22, fontSize: 20 },
        LARGE: { width: 26, height: 26, fontSize: 24 },
    },
    SWITCH: {
        MINI: { width: 46, height: 26, fontSize: 12 },
        SMALL: { width: 46, height: 26, fontSize: 16 },
        MEDIUM: { width: 46, height: 26, fontSize: 20 },
        LARGE: { width: 46, height: 26, fontSize: 24 },
    },
    SWITCH2: {
        MINI: { width: 46, height: 26, fontSize: 12 },
        SMALL: { width: 46, height: 26, fontSize: 16 },
        MEDIUM: { width: 46, height: 26, fontSize: 20 },
        LARGE: { width: 46, height: 26, fontSize: 24 },
    },
};

function checkbox(checked: boolean, size: TCheckboxSize, type: TCheckboxType, disabled: boolean) {
    const chOptions = checkboxOptions[type][size];

    return css({
        display: 'inline-flex',
        color: disabled ? colors.BLUE_LIGHTER : colors.NAVY,
        fontSize: chOptions.fontSize,

        '.container-checkbox': {
            display: 'inline-block',
            verticalAlign: 'middle',
            color: disabled ? colors.BLUE_LIGHTER : colors.NAVY,
        },

        // Hide checkbox visually but remain accessible to screen readers.
        // Source: https://polished.js.org/docs/#hidevisually
        '.hidden-checkbox': {
            border: 0,
            clip: 'rect(0 0 0 0)',
            clippath: 'inset(50%)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: 1,
        },

        '.styled-checkbox': {
            display: 'inline-flex',
            cursor: 'pointer',
            justifyContent: 'center',
            alignItems: 'center',
            width: chOptions.width,
            height: chOptions.height,
            borderRadius: 2,
            marginRight: 10,
            backgroundColor: checked ? colors.BLUE : colors.WHITE,
            border: `2px solid ${colors.BLUE}`,
            transition: 'all 150ms',

            img: {
                visibility: checked ? 'visible' : 'hidden',
            },
        },

        '.styled-switch': {
            borderRadius: 50, // just enough to make it round
            display: 'inline-block',
            cursor: 'pointer',
            width: chOptions.width,
            height: chOptions.height,
            backgroundColor: disabled ? colors.BLUE_LIGHTER : (checked ? colors.GREEN_BRIGHT : colors.NAVY_10),
            border: `2px solid ${disabled ? colors.BLUE_LIGHTER : (checked ? colors.GREEN_BRIGHT : colors.TRANSPARENT)}`,
            transition: 'all 350ms',

            '.switch-circle': {
                borderRadius: 50, // just enough to make it round
                position: 'relative',
                cursor: 'pointer',
                width: chOptions.height - 4,
                height: chOptions.height - 4,
                left: checked ? chOptions.width - chOptions.height : '0px !important',
                backgroundColor: colors.WHITE,
                transition: 'all 350ms',
            },
        },
        '.styled-switch-on-off': {
            borderRadius: 50, // just enough to make it round
            display: 'inline-block',
            cursor: 'pointer',
            width: '59px',
            height: '26px',
            backgroundColor: checked ? colors.GREEN_BRIGHT : colors.NAVY_10,
            border: `2px solid ${checked ? colors.GREEN_BRIGHT : colors.TRANSPARENT}`,
            transition: 'all 350ms',
            marginTop: '10px',

            '.switch-circle': {
                borderRadius: 50, // just enough to make it round
                position: 'relative',
                cursor: 'pointer',
                width: '22px',
                height: '22px',
                left: checked ? 32 : 0,
                backgroundColor: colors.WHITE,
                transition: 'all 350ms',

                '.onoffswitch-switch': {
                    fontSize: '13px',
                    marginLeft: '27px',
                    display: 'flex',
                    fontWeight: 600,
                    color: colors.BLACK,
                    position: 'relative',
                },

                '.onoffswitch-inner': {
                    fontSize: '13px',
                    marginLeft: '-24px',
                    display: 'flex',
                    fontWeight: 600,
                    color: colors.WHITE,
                    position: 'relative',
                }
            },
        }
    });
}

export default {
    checkbox: checkbox,
};
